import { Link } from 'react-router-dom';
import { useEffect } from 'react';

const sections = [
  {
    title: '2. Definitions',
    content: `For the purposes of these Terms:<br/>"Site" means this website and all related pages, features, and content<br/>"Company" refers to Regent Digital LTD<br/>"Service" means any content, materials, or functionality provided through the Site<br/>"User", "you" means any person accessing or using the Site<br/>"Content" means all text, graphics, logos, media, and materials available on the Site`,
  },
  {
    title: '3. Eligibility',
    content: `By using the Site, you confirm that:<br/>You are at least 18 years old or the age of majority in your jurisdiction<br/>You have the legal capacity to enter into binding agreements<br/>You will comply with all applicable laws and regulations`,
  },
  {
    title: '4. Use of the Site',
    content: `You agree to use the Site only for lawful purposes and in accordance with these Terms.<br/>You must not:<br/>Use the Site in violation of any applicable laws<br/>Attempt to gain unauthorized access to systems or data<br/>Interfere with the operation, security, or integrity of the Site<br/>Use automated tools (bots, scrapers) without authorization<br/>Engage in any activity that may harm the Company or other users`,
  },
  {
    title: '5. Intellectual Property Rights',
    content: `All Content and materials on the Site are owned by or licensed to Regent Digital LTD and are protected by intellectual property laws.<br/>You are granted a limited, non-exclusive, non-transferable license to access and use the Site for personal or internal business purposes.<br/>You may not:<br/>Copy, reproduce, or distribute Content without permission<br/>Modify or create derivative works<br/>Use Company branding, trademarks, or logos without written consent`,
  },
  {
    title: '6. User Content and Communications',
    content: `If you submit any content, inquiries, or communications through the Site:<br/>You retain ownership of your content<br/>You grant the Company a non-exclusive, royalty-free right to use such content for operational purposes (e.g., responding to inquiries)<br/>You confirm that your content does not violate any laws or third-party rights`,
  },
  {
    title: '7. Third-Party Services and Links',
    content: `The Site may contain links to third-party websites or services.<br/>The Company:<br/>Does not control third-party services<br/>Is not responsible for their content, availability, or policies<br/>Does not guarantee their accuracy or reliability<br/>Use of third-party services is at your own risk.`,
  },
  {
    title: '8. Disclaimer of Warranties',
    content: `The Site and all Content are provided on an "as is" and "as available" basis.<br/>To the fullest extent permitted by law, the Company:<br/>Makes no warranties regarding accuracy, completeness, or reliability<br/>Does not guarantee uninterrupted or error-free operation<br/>Does not guarantee the absence of viruses or harmful components`,
  },
  {
    title: '9. Limitation of Liability',
    content: `To the maximum extent permitted by law, Regent Digital LTD shall not be liable for:<br/>Any indirect, incidental, or consequential damages<br/>Loss of profits, data, or business opportunities<br/>Any damages arising from use or inability to use the Site<br/>Nothing in these Terms excludes liability that cannot be excluded under applicable law.`,
  },
  {
    title: '10. User Responsibility',
    content: `You are responsible for:<br/>Ensuring your use of the Site complies with applicable laws<br/>Maintaining the security of your devices and data<br/>Any actions taken while using the Site`,
  },
  {
    title: '11. Privacy and Data Protection',
    content: `Your use of the Site is subject to our Privacy Policy.<br/>We process personal data in accordance with applicable data protection laws, including UK GDPR where applicable.`,
  },
  {
    title: '12. Modifications to the Site and Terms',
    content: `The Company reserves the right to:<br/>Modify or discontinue any part of the Site at any time<br/>Update these Terms when necessary<br/>Updated Terms will be posted on this page. Continued use of the Site constitutes acceptance of the updated Terms.`,
  },
  {
    title: '13. Suspension and Termination',
    content: `We reserve the right to suspend or restrict access to the Site if:<br/>You violate these Terms<br/>Your use poses a risk to the Site or other users<br/>Required by law or regulatory authorities`,
  },
  {
    title: '14. Governing Law',
    content: `These Terms shall be governed by and interpreted in accordance with the laws of England and Wales.`,
  },
  {
    title: '15. Severability',
    content: `If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions shall remain in full force and effect.`,
  },
  {
    title: '16. Entire Agreement',
    content: `These Terms constitute the entire agreement between you and the Company regarding use of the Site and supersede any prior agreements.`,
  },
  {
    title: '17. Contact Information',
    content: `Regent Digital LTD<br/>International House<br/>55 Longsmith Street<br/>Gloucester<br/>GL1 2HT<br/>United Kingdom<br/>Email: support@regent-digital.com<br/>Phone: +447520657571`,
  },
];

export default function TermsOfUse() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="min-h-screen bg-[#0F0F0F]">
      {/* Navbar */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#1A1A1A] border-b border-white/10">
        <div className="px-8 md:px-16 py-4 flex items-center justify-between">
          <Link to="/" className="cursor-pointer flex items-center gap-3">
            <div className="relative w-10 h-10 flex items-center justify-center flex-shrink-0">
              <div className="absolute inset-0 bg-[#FFD93D] rounded-xl rotate-3" />
              <div className="absolute inset-0 bg-black rounded-xl -rotate-1" />
              <span
                className="relative z-10 font-black text-[#FFD93D]"
                style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '18px', letterSpacing: '-0.05em' }}
              >RD</span>
            </div>
            <div className="flex flex-col leading-none">
              <span
                className="text-white font-black uppercase"
                style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '22px', letterSpacing: '0.08em' }}
              >REGENT</span>
              <span
                className="text-[#FFD93D] font-black uppercase"
                style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '22px', letterSpacing: '0.08em' }}
              >DIGITAL</span>
            </div>
          </Link>

          <Link
            to="/"
            className="flex items-center gap-2 text-white/60 hover:text-[#FFD93D] transition-colors font-semibold text-sm cursor-pointer whitespace-nowrap"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-left-line" />
            </div>
            Back to Home
          </Link>
        </div>
      </nav>

      {/* Hero */}
      <div className="pt-32 pb-16 px-8 md:px-16 border-b border-white/10">
        <div className="max-w-4xl">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-1.5 h-8 bg-[#FFD93D] rounded-full" />
            <span
              className="text-[#FFD93D] font-black uppercase tracking-widest text-sm"
              style={{ fontFamily: "'Bebas Neue', sans-serif", letterSpacing: '0.2em' }}
            >Legal</span>
          </div>
          <h1
            className="text-white font-black uppercase mb-4"
            style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(48px, 7vw, 96px)', lineHeight: 0.9, letterSpacing: '-0.02em' }}
          >
            Terms of Use
          </h1>
          <p className="text-white/40 font-semibold text-sm mt-6">
            Last Updated: April 22, 2026
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="px-8 md:px-16 py-16">
        <div className="max-w-4xl">
          {/* Intro */}
          <p className="text-white/60 font-semibold text-base leading-relaxed mb-12 border-l-2 border-[#FFD93D] pl-6" dangerouslySetInnerHTML={{__html: `Welcome to this website (the "Site"), operated by Regent Digital LTD ("Company", "we", "our", or "us").<br/><br/>Registered Office:<br/>International House<br/>55 Longsmith Street<br/>Gloucester<br/>GL1 2HT<br/>United Kingdom<br/><br/>Contact Information:<br/>Email: support@regent-digital.com<br/>Phone: +447520657571<br/><br/>These Terms of Use ("Terms") govern your access to and use of the Site and any content, information, or services made available through it (collectively, the "Service").<br/><br/>By accessing or using the Site, you confirm that you have read, understood, and agree to be bound by these Terms, as well as our Privacy Policy and Cookie Policy. If you do not agree, you must not use the Site.`}} />

          {/* Sections */}
          <div className="space-y-10">
            {sections.map((section, index) => (
              <div
                key={index}
                className="group border border-white/10 rounded-xl p-8 hover:border-[#FFD93D]/30 transition-colors bg-[#1A1A1A]/50"
              >
                <h2
                  className="text-white font-black uppercase mb-4"
                  style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '22px', letterSpacing: '0.05em' }}
                >
                  {section.title}
                </h2>
                <p className="text-white/55 font-semibold text-sm leading-relaxed" dangerouslySetInnerHTML={{__html: section.content}} />
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="mt-16 border-t border-white/10 pt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <div>
              <p className="text-white/70 font-semibold text-base mb-1">
                Questions about our Terms?
              </p>
              <p className="text-white/40 font-semibold text-sm">
                Our team is happy to help clarify anything.
              </p>
            </div>
            <a
              href="mailto:support@regent-digital.com"
              className="bg-[#FFD93D] text-black font-black uppercase px-8 py-3 rounded-full hover:bg-[#FF8C42] hover:text-white transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
              style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '16px' }}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-mail-line" />
              </div>
              Contact Us
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[#1A1A1A] py-8 px-8 md:px-16 border-t border-white/10 mt-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 font-semibold text-sm">
            © 2026 Regent Digital LTD. All rights reserved. Registered in England &amp; Wales.
          </p>
          <Link
            to="/"
            className="text-white/40 hover:text-[#FFD93D] font-semibold text-sm transition-colors cursor-pointer whitespace-nowrap"
          >
            ← Back to Homepage
          </Link>
        </div>
      </footer>
    </div>
  );
}
